/* eslint-disable prettier/prettier */
export type VatRate = typeof vatRates[number];
export const vatRates = ['TWENTY_SEVEN', 'EIGHTEEN'] as const;

export type nullVatRate = typeof nullVatRates[number];
export const nullVatRates = ['ZERO'] as const;

export type allVatRate = typeof nullVatRates[number];
export const allVatRates = ['ZERO', 'TWENTY_SEVEN', 'EIGHTEEN'] as const;
